export default __webpack_public_path__ + "static/media/folder.8aa41610.png";